import { Button, TextInput } from "risa-oasis-ui_v2";
import { DetailsCard } from "../../../components/detailsCard/detailsCard";
import { DetailsCardItem, VisibilityState } from "../types/credentialTypes";

interface CredentialDetailsPanelProps {
  detailsCardData: DetailsCardItem[];
  passwordState: VisibilityState;
  secretKeyState: VisibilityState;
  hasCredentialId: boolean;
  hasSecretKey: boolean;
  onTogglePassword: () => void;
  onToggleSecretKey: () => void;
}

export const CredentialDetailsPanel = ({
  detailsCardData,
  passwordState,
  secretKeyState,
  hasCredentialId,
  hasSecretKey,
  onTogglePassword,
  onToggleSecretKey,
}: CredentialDetailsPanelProps) => {
  return (
    <div className="flex h-full flex-col">
      <div className="flex min-h-0 items-center justify-between pl-2">
        <div className="mb-2 font-semibold">Credential Details</div>
      </div>
      <div className="flex h-auto flex-1 flex-col overflow-auto p-1">
        <div className="rounded bg-gray-100 text-xl">
          <DetailsCard
            details={detailsCardData}
            elementsInOneRow={2}
            showBorder={true}
          />
        </div>

        <div className="credential-details-password-container mt-2 flex w-full flex-row items-end gap-3 py-3">
          <div className="w-1/2 items-center gap-2">
            <TextInput
              label="Password"
              defaultValue={
                passwordState.isVisible
                  ? passwordState.value
                  : "••••••••••••••••"
              }
              id="password"
              readOnly={true}
            />
          </div>

          <Button
            buttonType="primary"
            size="medium"
            disabled={passwordState.isLoading || !hasCredentialId}
            onClick={onTogglePassword}
          >
            {passwordState.isLoading
              ? "Loading..."
              : passwordState.isVisible
                ? "Hide Password"
                : "Show Password"}
          </Button>
        </div>
        <div className="credential-details-password-container mt-2 flex w-full flex-row items-end gap-3 py-3">
          <div className="w-1/2 items-center gap-2">
            <TextInput
              label="Secret Key"
              defaultValue={
                secretKeyState.isVisible
                  ? secretKeyState.value
                  : "••••••••••••••••"
              }
              id="secret-key"
              readOnly={true}
            />
          </div>

          <Button
            buttonType="primary"
            size="medium"
            disabled={secretKeyState.isLoading || !hasSecretKey}
            onClick={onToggleSecretKey}
          >
            {secretKeyState.isLoading
              ? "Loading..."
              : secretKeyState.isVisible
                ? "Hide Secret Key"
                : "Show Secret Key"}
          </Button>
        </div>
      </div>
    </div>
  );
};
